import create from "zustand";

export const useInfoStore = create((set) => ({
  courses: {},
  setCourses: (courses) => set((state) => ({ courses })),
}));
